<template>
  <b-modal
    id="viewAssessment"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    :visible="showModal"
    @hidden="$emit('close-modal')"
  >
    <div class="d-flex align-items-center justify-content-between p-3">
      <div class="b-modal-header">View Assessment</div>
      <div class="rotate-on-hover pointer">
        <img
          @click="$emit('close-modal')"
          v-b-tooltip.hover.top="'Close'"
          src="../../../assets/img/accessconnew/blueCross.svg"
          alt
        />
      </div>
    </div>
    <hr class="my-0 modal-hr" />
    <main class="p-4">
      <div class="slot-card mt-2">
        <article class="tag">Selected Test</article>
        <article class="vert-line"></article>
        <div class="d-flex w-100 mt-2">
          <section class="w-30">
            <div class="view-assess-sub-head">Topic Name:</div>
            <div class="view-assess-sub-body-text mt-1 text-truncate w-100">
              <b-skeleton v-if="loader"></b-skeleton>
              <span v-else v-b-tooltip.hover="testData.topicName">
                {{ testData.topicName }}
              </span>
            </div>
          </section>
          <section class="w-70 ml-3">
            <div class="view-assess-sub-head">Test Name</div>
            <div
              class="view-assess-sub-body-text mt-1 text-truncate w-100 pr-4"
            >
              <b-skeleton v-if="loader"></b-skeleton>
              <span v-else v-b-tooltip.hover="testData.testName">
                {{ testData.testName }}
              </span>
            </div>
          </section>
        </div>
      </div>
      <div class="slot-card mt-4">
        <article class="tag">Selected Configuration</article>
        <article class="vert-line"></article>
        <div class="w-100">
          <div class="d-flex w-100 mt-2">
            <section class="w-30 mr-3">
              <div class="view-assess-sub-head">Configuration Name</div>
              <div class="view-assess-sub-body-text mt-1 text-truncate w-100">
                <b-skeleton v-if="loader"></b-skeleton>
                <span v-else v-b-tooltip.hover="testData.configName">
                  {{ testData.configName }}
                </span>
              </div>
            </section>
            <section>
              <div class="view-assess-sub-head">Passing Percentage</div>
              <div class="view-assess-sub-body-text mt-1 text-truncate w-100">
                <b-skeleton v-if="loader"></b-skeleton>
                <span v-else>{{ currentAttempt.passingPercentage }}</span>
              </div>
            </section>
          </div>
          <div class="d-flex">
            <section class="w-30 mr-3">
              <div class="view-assess-sub-head mt-3">Starting Date</div>
              <div class="view-assess-sub-body-text mt-1">
                <b-skeleton v-if="loader"></b-skeleton>
                <span v-else>{{
                  formattedDate(testData.config.openTestdt)
                }}</span>
              </div>
            </section>
            <section>
              <div class="view-assess-sub-head mt-3">Ending Date</div>
              <div class="view-assess-sub-body-text mt-1">
                <b-skeleton v-if="loader"></b-skeleton>
                <span v-else>{{
                  formattedDate(testData.config.closeTestdt)
                }}</span>
              </div>
            </section>
          </div>
        </div>
      </div>
    </main>
    <hr class="my-0 modal-hr" />
    <footer class="p-3 d-flex justify-content-end">
      <b-button class="acs-cancelBtn-modal mr-3" @click="$emit('close-modal')"
        >Close</b-button
      >
    </footer>
  </b-modal>
</template>

<script>
import { getAssessmentMarks } from "@/utils/apiFunctions";
export default {
  name: "ViewAssessment",
  props: {
    showModal: Boolean,
    testValue: Object,
  },
  data() {
    return {
      loader: false,
      testData: { config: {} },
      attemptNo: null,
      currentAttempt: {},
    };
  },
  created() {
    this.loader = true;
    this.attemptNo = this.testValue.attemptNo;
    delete this.testValue.attemptNo;
    this.getAssessmentMarks();
  },
  methods: {
    formattedDate(str) {
      const date = new Date(str);
      const formattedDate = date.toLocaleDateString("en-GB");
      return formattedDate;
    },
    async getAssessmentMarks() {
      try {
        const res = await getAssessmentMarks(this.testValue);
        if (res.status == 200) {
          this.testData = res.data.data;
          this.currentAttempt = this.testData.config;
          this.loader = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
#triggerAssessment .modal-dialog {
  max-width: 600px !important;
}
.slot-card {
  box-shadow: 0px 4px 15px 0px #c4c4c480;
  background-color: #fcfcfc;
  border-radius: 4px;
  position: relative;
  display: flex;
  align-items: center;
  padding: 10px 5px 10px 40px;
}
.slot-card .tag {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 12px;
  letter-spacing: 0%;
  color: #038e00;
  background-color: #ccfacb;
  border-radius: 3px;
  padding: 2px 12px;
  position: absolute;
  left: 16px;
  top: -12px;
}
.slot-card .vert-line {
  background-color: #4ef085;
  width: 4px;
  height: 95%;
  border-radius: 2px;
  left: 5px;
  position: absolute;
}
.edit-icon-pos {
  position: absolute;
  top: 16px;
  right: 16px;
}

#viewAssessment .modal-dialog {
  max-width: 600px !important;
}

.view-assess-sub-head {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 13px;
  color: #696969;
}

.view-assess-sub-body-text {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 15px;
  color: var(--bluetheme);
}
</style>
